import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BellFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 21, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 24) / 21}
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3512 0C8.18122 0 6.10011 0.862023 4.5657 2.39643C3.03129 3.93084 2.16927 6.01195 2.16927 8.18193V14.5638L0.358331 17.2912C0.141271 17.6258 0.018152 18.0127 0.00185782 18.4112C-0.0144364 18.8098 0.0766933 19.2054 0.265711 19.5567C0.454728 19.908 0.734684 20.202 1.07628 20.408C1.41788 20.6139 1.80856 20.7243 2.20745 20.7276H18.495C18.8964 20.7262 19.29 20.6163 19.6341 20.4095C19.9782 20.2027 20.2599 19.9067 20.4494 19.5528C20.639 19.1989 20.7292 18.8003 20.7107 18.3992C20.6921 17.9982 20.5655 17.6097 20.3441 17.2748L18.5331 14.5638V8.18193C18.5331 6.01195 17.6711 3.93084 16.1367 2.39643C14.6023 0.862023 12.5212 0 10.3512 0Z"
        fill="currentColor"
      />
      <path
        d="M10.3514 24.0002C11.0275 23.9994 11.6869 23.7893 12.2387 23.3986C12.7906 23.0079 13.2079 22.4558 13.4333 21.8184H7.26953C7.49492 22.4558 7.91221 23.0079 8.46407 23.3986C9.01592 23.7893 9.67524 23.9994 10.3514 24.0002Z"
        fill="currentColor"
      />
    </svg>
  )
})

BellFilled.displayName = 'BellFilled'
